export enum BonusType {
    Wrvu = "Wrvu",
    Collections = "Collections",
    GrossCharges = "GrossCharges"
}
